module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/pesaro.6336d6e17a2f2ac0c0cf3718e694c439.jpg";